import { Snippet } from '@customTypes/Entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store';

export type SnippetsState = {
  selected: Array<number>;
  query: string;
  names: { [key: number]: string };
};

const initialState: SnippetsState = {
  selected: [],
  query: '',
  names: {},
};

export const snippetsSlice = createSlice({
  name: 'snippets',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    check: (state, action: PayloadAction<Snippet>) => {
      state.selected = state.selected.concat(action.payload.id);
      state.names[action.payload.id] = action.payload.name;
    },
    uncheck: (state, action: PayloadAction<number>) => {
      state.selected = state.selected.filter((s) => s !== action.payload);
      delete state.names[action.payload];
    },
    checkAll: (state, action: PayloadAction<Snippet[]>) => {
      state.selected = [];
      state.selected = state.selected.concat(action.payload.map((snippet) => snippet.id));
      action.payload.forEach((snippet) => (state.names[snippet.id] = snippet.name));
    },
    uncheckAll: (state) => {
      state.selected = [];
      state.names = {};
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
  },
});

export const { check, uncheck, checkAll, uncheckAll, setQuery } = snippetsSlice.actions;

export const getSelectedSnippets = (state: RootState) => state.snippets.selected;

export const getSelectedNamedSnippets = (state: RootState) =>
  Object.entries(state.snippets.names).map(([k, v]) => ({
    id: Number(k),
    name: v,
  }));

export const getSnippetsQuery = (state: RootState) => state.snippets.query;

export default snippetsSlice.reducer;
